// Installation facts that more than one page states. One place, so the
// measuring guide, the installer page, the configurator and the product page
// can never give different bracket counts or heights.
//
// Owner-confirmed 2026-09-27:
//   - Every awning hangs on two wall brackets, 6.5 cm in from each end of the
//     cassette. An awning 4 m wide or more needs a third bracket in the middle
//     (owner, 2026-09-30: from 4 m, not only over it).
//   - Three people for the lift from 4 m wide.
//   - Four anchors per bracket are supplied.
//   - About 2.4 m is the recommended mounting height - a standard, not a rule:
//     the front bar has to clear doors and paths at full projection.

export const THIRD_BRACKET_FROM_M = 4;
export const THREE_PEOPLE_FROM_M = 4;
export const ANCHORS_PER_BRACKET = 4;
export const RECOMMENDED_MOUNTING_HEIGHT_M = 2.4;

// "two brackets (three from 4 m wide)" - drop into running copy.
export const BRACKET_COUNT = `two brackets (three from ${THIRD_BRACKET_FROM_M} m wide)`;
